const urls = {
  images_production:
    "https://hiring-hub-production.s3-eu-west-1.amazonaws.com/images",
};

export { urls as default };
